"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windbarb = void 0;

var _skycover = require("./skycover");

var _utils = require("./utils");

var build = function (startY, windSpeed, strokeColor, strokeWidth, lineCap) {
  var offset = startY;
  var result = '';

  if (windSpeed <= 5) {
    return "\n\t\t\t<line\n\t\t\t\tx1=\"" + _skycover.DEFAULT_X + "\" y1=\"" + (4.5 + offset) + "\"\n\t\t\t\tx2=\"" + (_skycover.DEFAULT_X + 2) + "\" y2=\"" + (3.25 + offset) + "\"\n\t\t\t\tstroke=\"white\" stroke-width=\"1.5\"\n\t\t\t\tstroke-linecap=\"round\"\n\t\t\t/>\n\t\t\t<line\n\t\t\t\tx1=\"" + _skycover.DEFAULT_X + "\" y1=\"" + (4.5 + offset) + "\"\n\t\t\t\tx2=\"" + (_skycover.DEFAULT_X + 2) + "\" y2=\"" + (3.25 + offset) + "\"\n\t\t\t\tstroke=\"black\"\n\t\t\t\tstroke-width=\".5\"\n\t\t\t\tstroke-linecap=\"round\"\n\t\t\t/>\n\t\t";
  }

  while (windSpeed >= 5) {
    if (windSpeed >= 50) {
      result += "\n\t\t\t\t<polygon\n\t\t\t\t\tpoints=\"" + _skycover.DEFAULT_X + "," + (2 + offset) + " " + (_skycover.DEFAULT_X + 4) + "," + (2 + offset) + " " + _skycover.DEFAULT_X + "," + (4.5 + offset) + "\"\n\t\t\t\t\tfill=\"" + strokeColor + "\"\n\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\tstroke=\"" + strokeColor + "\"\n\t\t\t\t\tstroke-width=\"" + strokeWidth + "\"\n\t\t\t\t/>\n\t\t\t";
      offset += 2.75;
      windSpeed -= 50;
    } else if (windSpeed >= 10) {
      result += "\n\t\t\t\t<line\n\t\t\t\t\tx1=\"" + _skycover.DEFAULT_X + "\"\n\t\t\t\t\ty1=\"" + (3 + offset) + "\"\n\t\t\t\t\tx2=\"" + (_skycover.DEFAULT_X + 4) + "\"\n\t\t\t\t\ty2=\"" + (0.5 + offset) + "\"\n\t\t\t\t\tstroke=\"" + strokeColor + "\"\n\t\t\t\t\tstroke-width=\"" + strokeWidth + "\"\n\t\t\t\t\tstroke-linecap=\"" + lineCap + "\"\n\t\t\t\t/>\n\t\t\t";
      offset += 1.5;
      windSpeed -= 10;
    } else if (windSpeed >= 5) {
      result += "\n\t\t\t\t<line\n\t\t\t\t\tx1=\"" + _skycover.DEFAULT_X + "\" y1=\"" + (3 + offset) + "\"\n\t\t\t\t\tx2=\"" + (_skycover.DEFAULT_X + 2) + "\" y2=\"" + (1.75 + offset) + "\"\n\t\t\t\t\tstroke=\"" + strokeColor + "\"\n\t\t\t\t\tstroke-width=\"" + strokeWidth + "\"\n\t\t\t\t\tstroke-linecap=\"" + lineCap + "\"\n\t\t\t\t/>\n\t\t\t";
      windSpeed -= 5;
    }
  }

  return result;
};

var calm = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.radius,
      radius = _c === void 0 ? _skycover.BASE_RADIUS : _c,
      _d = _b.strokeColor,
      strokeColor = _d === void 0 ? 'black' : _d;

  return "\n\t" + (0, _skycover.circle)() + "\n\t" + (0, _skycover.circle)({
    radius: radius,
    strokeColor: strokeColor
  }) + "\n";
};

var flags = function (startY, windSpeed, windGust) {
  var result = '';
  var windSpeedInterval = (0, _utils.roundToInterval)(windSpeed, 5);
  var windGustInterval = (0, _utils.roundToInterval)(windGust, 5);
  result += build(startY, windGustInterval, 'white', 1.5, 'round');
  result += build(startY, windSpeedInterval, 'white', 1.5, 'round'); // TODO: wind gusts dont work for wind speeds <= 10. pass wind into
  // and color into function

  result += build(startY, windGustInterval, 'red', 0.5, 'round');
  result += build(startY, windSpeedInterval, 'black', 0.5, 'round');
  return result;
};

var windbarb = function (windSpeed, windGust, direction) {
  if (direction === void 0) {
    direction = 0;
  }

  var windSpeedInterval = (0, _utils.roundToInterval)(windSpeed, 5);
  var windGustInterval = (0, _utils.roundToInterval)(windGust, 5);

  if (!windSpeed || windSpeedInterval === 0) {
    return calm();
  }

  return "\n\t\t<g transform=\"" + (direction && "rotate(" + (direction || 0) + " " + _skycover.DEFAULT_X + " " + _skycover.DEFAULT_Y + ")") + "\">\n\t\t\t<line class=\"barb2\" x1=\"" + _skycover.DEFAULT_X + "\" y1=\"" + _skycover.DEFAULT_Y + "\" x2=\"" + _skycover.DEFAULT_X + "\" y2=\"" + (_skycover.DEFAULT_Y - 16) + "\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\n\t\t\t" + flags(_skycover.DEFAULT_Y - 19, windSpeedInterval, windGustInterval) + "\n\t\t\t<line class=\"barb\" x1=\"" + _skycover.DEFAULT_X + "\" y1=\"" + _skycover.DEFAULT_Y + "\" x2=\"" + _skycover.DEFAULT_X + "\" y2=\"" + (_skycover.DEFAULT_Y - 16) + "\" stroke=\"black\" stroke-width=\".5\" stroke-linecap=\"round\" />\n\t\t</g>\n\t";
};

exports.windbarb = windbarb;